module.exports = __webpack_public_path__ + "img/Frame 810.e7ab5621.svg";